// extracted by mini-css-extract-plugin
export default {"innerWrapper":"qu-z","tooltipWrapper":"ru-z","icon":"su-z","tooltip":"tu-z","content":"uu-z"};